<template>
	<div class="p-6">
		<h1 class="text-2xl font-semibold text-gray-900 mb-6">
			{{ __("Notifications") }}
		</h1>

		<ui-check-group
			class="col-span-3 flex pb-2 mb-px"
			v-model="form.reminder.expiring_bid"
			field="reminder.expiring_bid"
			label="Expiring offer"
			:form="form"
		></ui-check-group>
		<ui-check-group
			class="col-span-3 flex pb-2 mb-px"
			v-model="form.reminder.offer_out_of_date"
			field="reminder.offer_out_of_date"
			label="Listing no longer up to date"
			:form="form"
		></ui-check-group>
		<!--ui-check-group
			class="col-span-3 flex pb-2 mb-px"
			v-model="form.reminder.paper_offers_update"
			field="reminder.paper_offers_update"
			label="Daily Paper Market Notifications"
			:form="form"
		></ui-check-group-->
		<!--ui-check-groupui-check-group
			class="col-span-3 flex pb-2 mb-px"
			v-model="form.reminder.price_indication"
			field="reminder.price_indication"
			label="Price Ticker Notifications"
			:form="form"
		></ui-check-group-->
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
	},
};
</script>
